const settings = {
  tooltips: {
    openDelay: 1000
  }
}

export default settings
